<template>
  <div>
    <v-overlay :value="showOverlay"></v-overlay>

    <v-dialog
      v-model="sendSelectedMailDialogBool"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="headline">Are you sure you want to delete <br /> Selected Customers?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text>Cancel</v-btn>
          <v-btn color="blue darken-1" text>OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-card>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="customerList"
        item-key="email"
        show-select
        class="elevation-1"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-toolbar-title>Customer List</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="mb-2 mr-2"
              @click="sendTextToSelected"
              v-if="selected.length > 0"
            >
              Text Selected
            </v-btn>
            <v-btn
              color="primary"
              dark
              class="mb-2 mr-2"
              @click="sendEmailToSelected"
              v-if="selected.length > 0"
            >
              Email Selected
            </v-btn>
          </v-toolbar>
        </template>
        
        <template v-slot:[`item.sendText`]="{ item }">
          <v-btn
            small
            class="mr-2"
            :disabled="!item.phone"
            @click="sendText(item)"
          >
            Send Text
          </v-btn>
        </template>
        <template v-slot:[`item.sendEmail`]="{ item }">
          <v-btn
            small
            class="mr-2"
            :disabled="!item.email"
            @click="sendEmail(item)"
          >
            Send Email
          </v-btn>
        </template>
        <template v-slot:[`item.slpAgreement`]="{ item }">
          <v-btn
            small
            class="mr-2"
            @click="openLink(item.pdfUrl)"
          >
            Preview Document
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="getCustomers"
          >
            Reset
          </v-btn>
        </template>
        <template 
          v-slot:item.date="{ item }"
        >
          <!-- <span>{{ new Date(item.date).toLocaleString() }}</span> -->
          <span> {{new Date(item.date).toDateString()}} </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { DB } from '../firebase/db'
import { mapState } from 'vuex'
import { Functions } from '../firebase/functions'

import _ from 'lodash'

const textSlpAgreement = Functions.httpsCallable('textSlpAgreement')
const emailSlpAgreement = Functions.httpsCallable('emailSlpAgreement')

export default {
  name: 'CustomerList',
  data() {
    return {
      sortBy: 'date',
      sendSelectedMailDialogBool: false,
      sortDesc: true,
      showOverlay: false,
      companyName: '',
      serviceName: '',
      serviceDescription: '',
      businessPhone: '',
      businessEmail: '',
      businessAddress: null,
      billDate: undefined,
      customerList: [],
      selected: [],
      headers: [
        {
          text: 'First Name',
          align: 'start',
          sortable: false,
          value: 'firstName',
        },
        { text: 'Last Name', value: 'lastName' },

        { text: 'Preview Document', value: 'slpAgreement', sortable: false },
        { text: 'Send Text', value: 'sendText', sortable: false },
        { text: 'Send Email', value: 'sendEmail', sortable: false },

        { text: 'Address', value: 'address' },
        { text: 'City', value: 'city' },
        { text: 'State', value: 'state' },
        { text: 'Zip', value: 'zip' },
        { text: 'Phone', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'Number of Services Per Year', value: 'numberOfServices' },
        { text: 'Percent Discount', value: 'percentDiscount' },
        { text: 'Regular Price', value: 'regularPrice' },
        { text: 'Level Pay Monthly Cost', value: 'levelPayMonthlyCost' },
        { text: 'Offer Deadline', value: 'deadline' },
        { text: 'Agreement Sent Date', value: 'agreementSentDate' },
        { text: "Date Added", value: "date", dataType: "Date" }        
      ],
    }
  },
  computed: {
    ...mapState(['user', 'maxCustomers']),
  },
  methods: {
    getCustomers(){
      let docRef = DB.collection('user').doc(this.user.uid)
        docRef.get()
          .then((user) => {
            user = user.data()
            this.companyName = user.slpAgreement.companyName
            this.serviceName = user.slpAgreement.serviceName
            this.serviceDescription = user.slpAgreement.serviceDescription || ''
            this.businessPhone = user.slpAgreement.businessPhone || ''
            this.businessEmail = user.slpAgreement.businessEmail || ''
            this.businessAddress = user.slpAgreement.address || null
            this.billDate = user.slpAgreement.billDate
            if (!user.customerList) {
              this.customerList = []
            } else {
              this.customerList = user.customerList
            }
          })
    },

    updateFirebase() {
      let customerAccountRef = DB.collection("user").doc(this.user.uid)

      customerAccountRef
        .set({
          customerList: this.customerList
        }, { merge: true })
        .then(() => {
          this.reloadCustomerComponent()
          this.getCustomers()
        })
        .catch((err) => {
          console.error('Error setting Document: ', err)
        })
    },

    reloadCustomerComponent() {
      this.$store.dispatch('iterateKey')
    },

    openLink(link) {
      window.open(link, '_blank')
    },

    createTextPromise(item) {
      return new Promise((resolve, reject) => {
        textSlpAgreement({
          companyName: this.companyName,
          serviceName: this.serviceName,
          serviceDescription: this.serviceDescription,
          businessPhone: this.businessPhone,
          billDate: this.billDate,
          phone: item.phone,
          pdfUrl: item.pdfUrl,
          regularPrice: item.regularPrice,
          numberOfServices: item.numberOfServices,
          percentDiscount: item.percentDiscount,
          levelPayMonthlyCost: item.levelPayMonthlyCost,
          deadline: item.deadline,
        }).then(() => {
          resolve('Text Sent Successfully')
        }).catch((err) => {
          console.error('textSlpAgreement error:', err)
          reject(err?.message || 'Text not sent')
        })
      })
    },

    createEmailPromise(item) {
      return new Promise((resolve, reject) => {
        emailSlpAgreement({
          companyName: this.companyName,
          serviceName: this.serviceName,
          serviceDescription: this.serviceDescription,
          businessEmail: this.businessEmail,
          businessPhone: this.businessPhone,
          businessAddress: this.businessAddress,
          billDate: this.billDate,
          email: item.email,
          pdfUrl: item.pdfUrl,
          firstName: item.firstName,
          lastName: item.lastName,
          regularPrice: item.regularPrice,
          numberOfServices: item.numberOfServices,
          percentDiscount: item.percentDiscount,
          levelPayMonthlyCost: item.levelPayMonthlyCost,
          deadline: item.deadline,
        }).then(() => {
          resolve('Email Sent Successfully')
        }).catch(() => {
          reject('Email not sent :(')
        })
      })
    },

    sendText(item) {
      let p = this.createTextPromise(item)
      this.showOverlay = true

      p.then((message) => {
        this.showOverlay = false
        this.updateCustomerList(item)
        this.updateFirebase()
        alert(message)
      }).catch((message) => {
        this.showOverlay = false
        alert(message)
      })

    },

    sendEmail(item) {
      let p = this.createEmailPromise(item)
      this.showOverlay = true

      this.updateCustomerList(item)

      p.then((message) => {
        this.showOverlay = false
        this.updateCustomerList(item)
        this.updateFirebase()
        alert(message)
      }).catch((message) => {
        this.showOverlay = false
        alert(message)
      })

    },

    sendTextToSelected() {
      let promises = []
      this.showOverlay = true

      _.forEach(this.selected, (customer) => {
        promises.push(this.createTextPromise(customer))
        this.updateCustomerList(customer)
      })

      Promise.all((promises)).then(() => {
        this.showOverlay = false
        alert('Success :)')
        this.selected = []
        this.updateFirebase()
      }).catch(() => {
        this.showOverlay = false
        alert('There was an error :(')
        this.selected = []
      })
    },

    updateCustomerList(customer) {
      let currentDate = new Date()
      let index = _.findIndex(this.customerList, (cus) => {
        return (customer.firstName === cus.firstName && customer.lastName === cus.lastName && customer.email === cus.email)
      })

      this.customerList[index].agreementSentDate = currentDate.toDateString()
    },

    sendEmailToSelected() {
      let promises = []
      this.showOverlay = true

      _.forEach(this.selected, (customer) => {
        promises.push(this.createEmailPromise(customer))
        this.updateCustomerList(customer)
      })

      this.updateFirebase()

      Promise.all((promises)).then(() => {
        this.showOverlay = false
        alert('Success :)')
        this.selected = []
        this.updateFirebase()
      }).catch(() => {
        this.showOverlay = false
        alert('There was an error :(')
        this.selected = []
      })
    }
  },
  components: {},
  mounted() {
    this.getCustomers()
  },
}
</script>

<style scoped>

</style>